module.exports = __webpack_public_path__ + "img/home_lip.f9e4a026.png";